module.exports = __webpack_public_path__ + "static/media/finance.208885d0.png";